import axios from 'axios';

export function setInterceptorLocaleHeader(locale, getCurrentLocale){
    axios.interceptors.request.use(function (config){
        config.headers['language'] = getCurrentLocale();
        return config
    }, function(error){
        return Promise.reject(error)
    })
}